import React, { useContext } from "react";
import { LanguageContext } from "../context/LanguageContext";

const LanguageSelector = () => {
  const { language, setLanguage } = useContext(LanguageContext);

  const languages = [
    { code: "en", name: "English", flag: "🇬🇧" },
  ];

  /*

    { code: "de", name: "Deutsch", flag: "🇩🇪" },
    { code: "ro", name: "Română", flag: "🇷🇴" },

  */

  return (
    <div className="language-selector">
      {languages.map((lang) => (
        <button
          key={lang.code}
          onClick={() => setLanguage(lang.code)}
          className={`language-btn ${language === lang.code ? "active" : ""}`}
          title={lang.name}
        >
          {lang.flag}
        </button>
      ))}
    </div>
  );
};

export default LanguageSelector;
